module.exports = __webpack_public_path__ + "static/img/avatarNon.daf78924.png";